<template>
  <div>
    <div class="export-body" id="export">
      <div class="export-left">
        <div class="export-title">{{ $t("langcfg.txtPatientList") }}</div>
        <div style="height: 80px"></div>
        <div class="export-table">
          <div id="xu">
            <el-date-picker
              v-model="value2"
              @change="datetime"
              class="datePicker"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="-"
              :start-placeholder="`${$t('langcfg.txtStartDate')}`"
              :end-placeholder="`${$t('langcfg.txtEndDate')}`"
              align="right"
            >
            </el-date-picker>
            <!--            @input="searchInput"-->
            <el-input
              v-model="namePid"
              :placeholder="`${$t('langcfg.txtNameOrPID')}`"
              style="width: 200px; float: left; margin-right: 50px"
              @click.native.prevent.stop="handleClick"
              @touchend.native.stop.prevent="handleClick"
            ></el-input>
            <span
              class="export-checkAll"
              :style="currentLanguage === 'de' ? 'margin-left: 25px' : ''"
              @click="checkedInputAllFun"
            >
              <i class="el-icon-success success" v-if="checkedAll"></i>
              <i class="el-icon-success" v-if="!checkedAll"></i>
              <span v-if="!checkedAll">{{ $t("langcfg.txtSelectAllPatients") }}</span>
              <span v-if="checkedAll">{{ $t("langcfg.txtDeselectAllPatients") }}</span>
            </span>
          </div>
          <el-table
            ref="patientsTable"
            :data="patientsData"
            tooltip-effect="dark"
            :row-style="rowCtyle"
            @row-click="showRecordList"
            :header-row-style="headerStyle"
            @select="onTableSelect"
            highlight-current-row
            :needSelectFirstRow="true"
            @selection-change="patientsSelection"
          >
            <el-table-column type="selection" align="center" width="50"> </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              header-align="center"
              align="center"
              v-for="(item, index) in patientHeaders"
              :key="index"
              :prop="item.prop"
              :label="$t(`langcfg.${item.label}`)"
              :width="item.width"
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :background="true"
          style="margin-top: 80px"
          align="center"
          :page-size="pageSize"
          @current-change="currentChange"
          :current-page.sync="patientsPage"
          layout="prev, pager, next"
          :total="allPatientsCount"
          :pager-count="5"
        >
        </el-pagination>
      </div>
      <div class="export-center"></div>
      <div class="export-right">
        <div>
          <div class="export-title">
            {{ $t("langcfg.txtRecordList") }}
            <div style="float: right; width: 220px"></div>
          </div>
          <div style="height: 80px"></div>
          <el-select v-model="selectRecordValue" id="select" @change="selectRecord">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div class="export-table">
            <el-table
              ref="recordsTable"
              :data="recordsData"
              :row-style="rowCtyle"
              :header-row-style="headerStyle"
              highlight-current-row
              :lazy="true"
              :needSelectFirstRow="true"
              @select="onRecordTableSelect"
              @selection-change="recordsSelection"
            >
              <span style="color: rgba(255, 255, 255, 0.2)" slot="empty">{{
                $t("langcfg.txtNoData")
              }}</span>
              <el-table-column type="selection" align="center"> </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                header-align="center"
                align="center"
                v-for="(item, index) in headers"
                :key="index"
                :prop="item.prop"
                :label="$t(`langcfg.${item.label}`)"
                :width="item.width"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="setButton">
          <el-button class="progressButton" @click="progressInput" v-if="progressButton"
            >{{ $t("langcfg.txtShowProgress") }}
          </el-button>
          <el-button class="cancel" @click="cancel">{{
            $t("langcfg.txtReturnToHomePage")
          }}</el-button>
          <el-button type="primary" class="export" @click="exportFile">{{
            $t("langcfg.txtExport")
          }}</el-button>
        </div>
      </div>
    </div>
    <!--   v-show="false" v-show="showReport" style="position: absolute;  width: 40%;height: 70%; top: 0px;right:100px;opacity: 0.9" -->
    <!--      v-show="false"-->
    <Report
      v-show="false"
      :currentPatient="currentPatient"
      :recordOneInfo="recordOneInfo"
      :recordTwoInfo="recordTwoInfo"
      @exportFinished="exportFinished"
      :startShowReport="startShowReport2"
      :exportFilesPath="exportFilesPath"
    >
    </Report>
    <!--    角膜 导出pdf style="position: absolute;  width: 40%;height: 80%; top: 0px;left: 10px;bottom: 0;margin: auto; opacity: 0.9" -->
    <topographyReport
      v-show="false"
      :patient="topographyCurrentPatient"
      :checkDate="detailsMyself.recorddate"
      :currentEye="detailsMyselfEyeType"
      :record="detailsMyself"
      :exportFilesPath="topographyFilesPath"
      :mapValues="topographyMapValues"
      :startShowReport="startShowReport"
      :casePath="casePath"
      :hasTopographyReport="hasTopographyReport"
      @exportTopographyFinished="exportTopographyFinished"
    >
    </topographyReport>
    <!--    导出类型提示-->
    <div>
      <el-dialog
        :title="`${$t('langcfg.txtPrompt')}`"
        :visible.sync="dialogVisible"
        top="20px"
        :width="currentLanguage === 'de' ? '50%' : currentLanguage === 'ja' ? '45%' : '35%'"
        :before-close="handleClose"
      >
        <span class="txtSelectType">{{ $t("langcfg.txtSelectType") }}</span>
        <Option @exportStart="processExport" :hideOption="hideOption"></Option>
      </el-dialog>
    </div>
    <!--导出进度-->
    <div class="progress" v-if="progressShow">
      <div class="progress-close" @click="progressClose">
        <i class="el-icon-circle-close" style="font-size: 55px"></i>
      </div>
      <div style="margin: 20% auto auto">
        <div class="progressText" v-if="WaitExport">
          {{ $t("langcfg.txWaitExport") }}
        </div>
        <div class="progressText" v-else>
          {{ $t("langcfg.txtNowExportProgress") }} {{ percentage }}%
        </div>
      </div>
    </div>
    <!--    返回菜单提示-->
    <div>
      <el-dialog
        :title="`${$t('langcfg.txtPrompt')}`"
        :visible.sync="dialogVisibleHome"
        width="30%"
        :before-close="handleClose"
      >
        <div class="dialogHome-content">
          {{ $t("langcfg.txtSureReturnToHomePage") }}
        </div>
        <div class="setButton">
          <el-button @click="backHomeClose" class="cancel">{{ $t("langcfg.txtCancel") }}</el-button>
          <el-button type="primary" class="export" @click="backHome">{{
            $t("langcfg.txtReturnToHomePage")
          }}</el-button>
        </div>
        <div style="clear: both"></div>
      </el-dialog>
    </div>
    <!--    -->
    <div>
      <el-dialog
        :title="`${$t('langcfg.txtPrompt')}`"
        :visible.sync="dialogVisibleFile"
        width="30%"
        :before-close="handleClose"
      >
        <div class="dialogHome-content">
          {{ $t("langcfg.txtExportFileMsg") }}
        </div>
        <div class="setButton">
          <el-button @click="fileExportClose" class="cancel">{{
            $t("langcfg.txtCancel")
          }}</el-button>
          <el-button type="primary" class="export" @click="fileExport">{{
            $t("langcfg.txtAgainExport")
          }}</el-button>
        </div>
        <div style="clear: both"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as patient from "../../../services/patient";
import * as record from "../../../services/record";
import { recordExportHeaders } from "../../../services/record";
import exportFileData from "../../js/exportUserList";
import Option from "./option";
import Report from "./report";
import topographyReport from "./topographyReport";
import moment from "moment";
import { FILES } from "../../../topography/shared";
import { mapGetters } from "vuex";
import EVENTS from "../../../bus";
import fileSys from "../../../fileoprators/fileSystem";
import { Message } from "../../../mixins";
import ExportEyeJson from "../../../topography/js/exportEyeJson";
import ExportMwfXml from "../../../topography/js/exportMwfXml";
import { getSystemTime, isDefined, logStdout } from "../../../shared/utils";
const exec = window.require("child_process").exec;

let exportEye, exportMwf;
export default {
  name: "index",
  // props: ['getExportRecords', 'patientHeaders', 'currentRecord'],
  props: ["patientHeaders"],
  computed: {
    ...mapGetters(["dataShowSettings"])
  },
  data() {
    return {
      WaitExport: false,
      // 导出错误提示
      dialogVisibleFile: false,
      dialogVisibleHome: false,
      showReport: true,
      topographyCurrentPatient: "",
      currentPatient: "",
      currentPatient2: "",
      recordTwoInfo: "",
      recordOneInfo: "",
      exportFinishedType: false,
      // 存储干眼和角膜导出报告路径
      exportFilesPath: "",
      // 存储单个病例
      getNowExportRecords: "",
      // 存储单个病例数量
      getNowExportNum: "",
      // 存储单个病例callback
      getNowExportCallback: "",
      // 存储单个路径
      getNowExportPaths: "",
      // 存储选中类型
      getNowExportExportType: "",
      // 终止导出状态
      stopExportType: false,
      progressButton: false,
      progressShow: false,
      progress: 0,
      percentage: 0,
      dialogVisible: false,
      namePid: "",
      options: [
        {
          value: "dryeye",
          label: this.$t("langcfg.txtDryEye")
        },
        {
          value: "topography",
          label: this.$t("langcfg.txtTopography")
        },
        {
          value: "",
          label: this.$t("langcfg.txtAll")
        }
      ],
      selectRecordValue: "",
      checkedAll: false,
      patientChecked: false,
      recordChecked: false,
      headers: recordExportHeaders.concat(),
      patientsData: [],
      patientsPage: 1,
      patientsLimit: 10,
      patientsSearch: {},
      recordsData: [],
      currentPatients: "",
      pageSize: 10,
      allPatientsCount: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("langcfg.txtLastWeek"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t("langcfg.txtLastMonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t("langcfg.txtLastThreeMonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      value2: "",
      getStartTime: "",
      getEndTime: "",
      //  下面是对用户列表单全选操作存储
      // 病人总的未选值 （仅限于勾选全部）
      pNoCheckAllArr: [],
      // 当前页总的选中病人值
      pCheckCurrentArr: [],
      // 病例未选值
      reNoCheckAllArr: [],
      // 病例已选值
      recordCheckCurrentArr: [],
      // 所有病例
      recordAll: [],
      // 所有病例的详细信息
      recordAllDetails: [],
      patientsArr: [],
      patientCheckNum: 0,
      isPatientCheck: true,
      // 用来计算病例列表显示的次数
      recordNum: 0,
      // 存储原图
      getTopographyOriginImage: [],
      // 当前病例信息
      detailsMyself: "",
      // 存储角膜报告 mapValues
      topographyMapValues: "",
      detailsMyselfEyeType: "",
      topographyFilesPath: "",
      // 存角膜四象图
      topographyFourPath: "",
      // 每次角膜渲染报告
      startShowReport: "",
      // 乾眼
      startShowReport2: "",
      // 获取角膜左右眼状态
      hasTopographyReportEyeType: false,
      // 勾选病例后单个病人不能全选
      hasSinglePatientCheck: false,
      hasTopographyReport: exportFileData.hasTopographyReport,
      casePath: "",
      //   导出根目录
      exportRootPath: "/home/mw520/MwData",
      exportRootFile: "/home/mw520/Udisk",
      compressFileStatus: "",
      hideOption: true,
      currentLanguage: ""
    };
  },
  components: {
    Option,
    Report,
    topographyReport
  },
  mixins: [Message],
  created() {
    this.currentLanguage = window.settings.language;
  },
  methods: {
    rowCtyle() {
      return {
        fontSize: "24px",
        background: "transparent",
        height: "60px"
      };
    },
    headerStyle() {
      return {
        fontSize: "25px",
        background: "transparent",
        height: "50px"
      };
    },
    // 显示键盘
    handleClick() {
      let _this = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, this.namePid, (value) => {
        _this.namePid = value;
        _this.searchInput();
      });
    },
    // 病例列表全选
    recordsSelection(val) {
      if (!this.currentPatients) {
        return;
      }
      this.recordNum = this.recordNum + val.length;
      //  触发病例全选
      if (val.length === this.recordsData.length && this.recordsData.length > 0) {
        this.recordCheckCurrentArr = this.recordsData;
        this.recordNum = 0;
        setTimeout(() => {
          if (this.recordNum === 0) {
            this.selectPatientOne(val[0], val);
            this.getRecordNoCheckArrFun();
          }
        }, 10);
      }
      // 列表为空
      if (val.length === 0 && this.recordsData.length > 0) {
        this.recordCheckCurrentArr = [];
        setTimeout(() => {
          if (this.recordNum === 0) {
            this.selectPatientOne("", []);
            this.getRecordNoCheckArrFun();
          }
        }, 10);
      }
    },
    // 病例单个已选和未选方法
    onRecordTableSelect(rows, row) {
      this.recordCheckCurrentArr = rows;
      if (this.patientsData.length <= 1) {
        if (!this.currentPatientIsChecked(this.patientsData[0])) {
          this.getRecordNoCheckArrFun();
        } else {
          this.getRecordNoCheckArrFun();
        }
      } else {
        this.getRecordNoCheckArrFun();
      }
      this.selectPatientOne(row, rows);
      // --原版--
      // this.recordCheckCurrentArr = rows
      // this.selectPatientOne(row, rows)
      // this.getRecordNoCheckArrFun()
    },
    //  显示病人勾选
    selectPatientOne(row, rows) {
      for (let i = 0; i < this.patientsData.length; i++) {
        if (this.patientsData[i]._id === this.currentPatients._id) {
          if (rows.length > 0 && row) {
            this.$refs.patientsTable.toggleRowSelection(this.patientsData[i], true);
            this.getNoCheckArrFun(true, this.patientsData[i]);
          } else {
            this.$refs.patientsTable.toggleRowSelection(this.patientsData[i], false);
            this.getNoCheckArrFun(false, this.patientsData[i]);
          }
        }
      }
    },
    // 病例类型选择
    selectRecord(data) {
      this.selectRecordValue = data;
      this.recordsAll();
    },
    // 病例未选数组
    getRecordNoCheckArrFun() {
      let recordNoArr = [];
      for (let i = 0; i < this.recordsData.length; i++) {
        let flag = false;
        for (let j = 0; j < this.recordCheckCurrentArr.length; j++) {
          if (this.recordsData[i]._id === this.recordCheckCurrentArr[j]._id) {
            flag = true;
          }
        }
        if (!flag) {
          recordNoArr.push(this.recordsData[i]);
        }
      }
      // 删除当前
      if (this.reNoCheckAllArr) {
        for (let i = 0; i < this.recordsData.length; i++) {
          for (let j = 0; j < this.reNoCheckAllArr.length; j++) {
            if (this.reNoCheckAllArr[j]._id === this.recordsData[i]._id) {
              this.reNoCheckAllArr.splice(j, 1);
            }
          }
        }
      }
      // 合并未选 如果一个都没选，不加入数组
      if (recordNoArr.length < this.recordsData.length) {
        this.reNoCheckAllArr.push.apply(this.reNoCheckAllArr, recordNoArr);
      }
    },
    // 病例列表
    recordsAll() {
      let _this = this;
      record.exportGetRecordsAll(this.currentPatients._id, this.selectRecordValue, function (data) {
        _this.recordsData = data.records.map((item) => {
          item.checktype =
            item.checktype === "dryeye"
              ? _this.$t("langcfg.txtDryEye")
              : _this.$t("langcfg.txtTopography");
          return item;
        });
        if (data.records.length > 0) {
          _this.$refs.recordsTable.setCurrentRow(_this.recordsData[0]);
          const isCheckType = _this.currentPatientIsChecked(_this.currentPatients);
          setTimeout(() => {
            _this.recordSelectedAllFun(isCheckType);
          }, 0);
        }
      });
    },

    // 病例全选方法
    recordSelectedAllFun(type) {
      for (let i = 0; i < this.recordsData.length; i++) {
        this.$refs.recordsTable.toggleRowSelection(this.recordsData[i], type);
        //  显示未选中
        if (this.reNoCheckAllArr.length > 0) {
          for (let j = 0; j < this.reNoCheckAllArr.length; j++) {
            if (this.recordsData[i]._id === this.reNoCheckAllArr[j]._id) {
              this.$refs.recordsTable.toggleRowSelection(this.recordsData[i], false);
            }
          }
        }
      }
    },
    // 时间搜索值
    datetime(data) {
      this.getStartTime = data ? moment(data[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.getEndTime = data ? moment(data[1]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.value2 = data || "";
      this.patientsSearchFun();
    },
    // 名称搜索
    searchInput() {
      this.patientsSearchFun();
    },
    //  病人搜索值封装
    patientsSearchFun() {
      this.patientsSearch = {};
      if (this.namePid || (this.getStartTime && this.getEndTime)) {
        this.patientsSearch = {
          namePid: this.namePid,
          getStartTime: this.getStartTime,
          getEndTime: this.getEndTime
        };
      } else {
        this.patientsSearch = {};
      }
      this.patientsPage = 1;
      this.patientsAll();
    },
    // 病人列表
    patientsAll() {
      this.getTopographyOriginImage = [];
      // this.getTopographyOriginImage.push(exportFileData.getTopographyOriginImage())
      // console.log('getTopographyOriginImage', this.getTopographyOriginImage)
      let _this = this;
      patient.exportGetPatientsAll(
        this.patientsPage,
        this.patientsLimit,
        this.patientsSearch,
        function (data) {
          _this.allPatientsCount = data.count;
          for (let i = 0; i < data.patients.length; i++) {
            if (data.patients[i].hasOwnProperty("sex")) {
              // 导出界面中病人sex原始值被更改，增加备份原始sex值
              data.patients[i].sexdb = data.patients[i].sex;
              if (data.patients[i].sex === "F") {
                data.patients[i].sex = _this.$t("langcfg.txtFemale");
              } else if (data.patients[i].sex === "M") {
                data.patients[i].sex = _this.$t("langcfg.txtMale");
              } else if (data.patients[i].sex === "O") {
                data.patients[i].sex = _this.$t("langcfg.txtSexOther");
              } else if (data.patients[i].sex === "U") {
                data.patients[i].sex = _this.$t("langcfg.txtSexUnknown");
              }
            }
          }
          _this.patientsData = data.patients;
          if (data.count > 0) {
            if (_this.checkedAll) {
              // 存储已选值
              // exportFileData.patientCheckAll(_this.patientsData)
              _this.checkedAllFun();
            }
            _this.currentPatients = data.patients[0];
            // 默认显示第一行
            _this.$refs.patientsTable.setCurrentRow(data.patients[0]);
            // 显示病例
            _this.recordsAll();
          } else {
            _this.recordsData = [];
          }
        }
      );
    },
    // 病人未选数组
    getNoCheckArrFun(type, row) {
      if (type) {
        for (let i = 0; i < this.pNoCheckAllArr.length; i++) {
          if (row._id === this.pNoCheckAllArr[i]._id) {
            this.pNoCheckAllArr.splice(i, 1);
          }
        }
      } else {
        this.pNoCheckAllArr.push(row);
      }
      const arr = exportFileData.removeSame(this.pNoCheckAllArr);
      this.pNoCheckAllArr = arr;
    },
    // 获取病人所有数据
    patientsAllData(callback) {
      patient.exportGetPatientsAllData(function (data) {
        callback(data.obj);
      });
    },
    // ---------导出操作----------
    // 导出所有病人病例
    exportRecordAllData(paths, exportType, exportPath) {
      let patientsArr; // 最后病人id
      let _this = this;
      this.patientsAllData(function (data) {
        if (_this.checkedAll) {
          patientsArr = exportFileData.removeSamePatients(data.patients, _this.pNoCheckAllArr);
        } else {
          patientsArr = _this.pCheckCurrentArr;
        }
        if (patientsArr.length < 1) {
          _this.notify("error", _this.$t("langcfg.txtSelectPatient"));
          return;
        }
        _this.patientsArr = patientsArr;
        _this.recordAll = [];
        _this.stopExportType = false;
        _this.progressShow = true;
        // 清空表格数据
        exportFileData.saveUserDryeyeTable = [];
        exportFileData.saveUserTopographyTable = [];
        _this.recursionRecord(paths, patientsArr, exportType, 0, function (type) {
          if (type) {
            if (_this.percentage >= 100) {
              //  恢復病例 = 0
              _this.getNowExportNum = 0;
              _this.getNowExportRecords = "";
              _this.getNowExportPaths = "";
              _this.getNowExportExportType = "";
              _this.getNowExportCallback = "";
              // 角膜左右眼为false
              _this.hasTopographyReportEyeType = false;
              _this.exportFilesPath = "";
              // 到终点延迟消失
              _this.progressButton = false;
              // 是否生成表格
              _this.WaitExport = true;
              exportFileData.exportTableData(function (type) {
                if (type) {
                  if (exportPath) {
                    fileSys.sync();
                    _this.progressShow = false;
                    _this.WaitExport = false;
                    _this.message(_this.$t("langcfg.txtExportSuccess"), "success", 3000);
                    return;
                  }
                  exportFileData.compressFile(_this.exportRootPath, function (status) {
                    _this.compressFileStatus = status;
                    if (status.type) {
                      // 比对内存
                      exportFileData.compare(
                        _this.exportRootPath,
                        _this.exportRootFile,
                        status.fileName,
                        function (type) {
                          if (!type) {
                            // exec(`umount /media/mw520/*; umount /home/mw520/Udisk`)
                            _this.message(_this.$t("langcfg.txOutOfMemory"), "error", 3000);
                            _this.progressShow = false;
                            _this.WaitExport = false;
                          } else {
                            exportFileData.copyToUdisk(
                              _this.exportRootPath,
                              _this.exportRootFile,
                              status.fileName,
                              function (type) {
                                // exec('umount /media/mw520/*; umount /home/mw520/Udisk')
                                if (type) {
                                  _this.message(
                                    _this.$t("langcfg.txtExportSuccess"),
                                    "success",
                                    3000
                                  );
                                  // _this.notify('success', _this.$t('langcfg.txtExportSuccess'))
                                  // 清空文件
                                  exportFileData.clearFile(_this.exportRootPath, function (type) {
                                    if (type) {
                                    }
                                  });
                                  setTimeout(function () {
                                    _this.progressShow = false;
                                    _this.WaitExport = false;
                                  }, 500);
                                } else {
                                  _this.progressShow = false;
                                  _this.dialogVisibleFile = true;
                                }
                              }
                            );
                          }
                        }
                      );
                    }
                  });
                }
              });
            }
          }
        });
      });
    },
    // 递归病人自己查找病例
    recursionRecord(paths, patientsArr, exportType, num, callback) {
      this.progressSum(num, patientsArr.length);
      let _this = this;
      if (num < patientsArr.length) {
        this.selectRecordValue = this.options[2].value;
        let patientMyself = patientsArr[num];
        _this.topographyCurrentPatient = patientMyself;
        record.exportGetRecordsAll(patientMyself._id, this.selectRecordValue, function (data) {
          // 角膜左右眼为false
          _this.hasTopographyReportEyeType = false;
          if (data.records.length > 0) {
            _this.recordAll = data.records;
            _this.recordAllDetails = [];
            if (_this.recordAll.length > 0) {
              _this.currentPatient = patientMyself;
              for (let i = 0; i < _this.recordAll.length; i++) {
                for (let j = 0; j < _this.reNoCheckAllArr.length; j++) {
                  if (_this.recordAll[i]) {
                    if (_this.recordAll[i]._id === _this.reNoCheckAllArr[j]._id) {
                      _this.recordAll.splice(i, 1);
                    }
                  }
                }
              }
              _this.recordDetails(
                paths,
                exportType,
                _this.recordAll,
                0,
                function (recordAllDetails) {
                  // 递归病人
                  //  恢復病例 = 0
                  _this.getNowExportNum = 0;
                  if (isDefined(exportEye)) {
                    exportEye.save(_this.currentPatient, paths + "/dea520");
                    exportEye = null;
                  }
                  if (isDefined(exportMwf)) {
                    exportMwf.save(_this.currentPatient, paths + "/dea520");
                    exportMwf = null;
                  }
                  // if (recordAllDetails) {
                  if (!_this.stopExportType) {
                    num++;
                    _this.recursionRecord(paths, patientsArr, exportType, num, callback);
                  }
                  // }
                }
              );
            } else {
              const arr = [];
              arr.push(patientMyself);
              let topographyOriginalObj = {
                // 角膜
                name: FILES.originImage,
                corneaOSImg: "",
                corneaODImg: "",
                // 瞳孔
                pupilName: "pupil_" + FILES.originImage,
                pupilOSImg: "",
                pupilODImg: ""
              };
              exportFileData.exportPath(
                paths,
                _this.recordAll,
                arr,
                {},
                exportType,
                {},
                topographyOriginalObj,
                function (data) {
                  // patient.exportPath(paths, _this.recordAll, arr, {}, exportType, {}, topographyOriginalObj, function (data) {
                  // 终止后不再执行导出
                  if (data) {
                    if (!_this.stopExportType) {
                      _this.recursionRecord(paths, patientsArr, exportType, num, callback);
                    }
                  }
                }
              );
            }
          } else {
            num++;
            _this.recursionRecord(paths, patientsArr, exportType, num, callback);
          }
        });
      } else {
        const type = true;

        callback(type);
      }
    },
    // 查询病例情况
    recordDetails(paths, exportType, getExportRecords, num, callback) {
      // 只有一个病人但是有很多病例的导出进度
      if (this.patientsArr.length === 1) {
        this.progressSum(num, getExportRecords.length);
      }
      let _this = this;
      _this.recordAllDetails = [];
      _this.getNowExportNum = num;
      if (_this.getNowExportNum < getExportRecords.length) {
        _this.getNowExportRecords = getExportRecords;
        _this.getNowExportPaths = paths;
        _this.getNowExportExportType = exportType;
        _this.getNowExportCallback = callback;
        const detailsMyself = getExportRecords[_this.getNowExportNum];
        record.getRecordContent(detailsMyself._id, (data) => {
          // console.log('lilili', data)
          // 没有病例
          if (!data || data.message === "failed" || !data.hasOwnProperty("record")) {
            _this.getNowExportNum++;
            _this.recordDetails(
              paths,
              exportType,
              getExportRecords,
              _this.getNowExportNum,
              callback
            );
          } else {
            _this.detailsMyself = data.record;
            // --------------导出干眼报告和表格----------------------------------
            if (exportFileData.hasDryeyeTable) {
              exportFileData.saveTableData(data.record, _this.currentPatient);
            }
            let eyeType;
            if (data.hasOwnProperty("record")) {
              if (data.record.hasOwnProperty("eyetype")) {
                if (data.record.eyetype.length > 1) {
                  eyeType = data.record.eyetype[0] + "," + data.record.eyetype[1];
                  if (!_this.hasTopographyReportEyeType) {
                    _this.detailsMyselfEyeType = data.record.eyetype[0];
                  } else {
                    _this.detailsMyselfEyeType = data.record.eyetype[1];
                  }
                } else if (data.record.eyetype.length === 1) {
                  eyeType = data.record.eyetype[0];
                  _this.detailsMyselfEyeType = eyeType;
                }
                data.record.content.dataOS.data = {
                  date: detailsMyself.recorddate,
                  type: eyeType
                };
                data.record.content.dataOD.data = {
                  date: detailsMyself.recorddate,
                  type: eyeType
                };
                // 传值给报告，用于打印报告
                let val = {
                  _id: data.record._id,
                  patientid: data.record.patientid,
                  eyeType: eyeType,
                  dataOD: data.record.content.dataOD,
                  dataOS: data.record.content.dataOS,
                  checkType: data.record.checktype
                };
                _this.recordAllDetails.push(val);
              }
            }
            let arr = [];
            arr.push(_this.currentPatient);
            // ---------------------这里是导出角膜和瞳孔原图-----------------------------------------------------------------------------
            let topographyOriginalObj = {
              // 角膜
              name: FILES.originImage,
              corneaOSImg: "",
              corneaODImg: "",
              // 瞳孔
              pupilName: "pupil_" + FILES.originImage,
              pupilOSImg: "",
              pupilODImg: ""
            };
            // topographyOriginalImage
            _this.getTopographyImagePath(
              data.record,
              eyeType,
              topographyOriginalObj,
              function (topographyOriginal, error) {
                // 判断选择导出角膜和瞳孔原图
                if (error) {
                  _this.getNowExportNum++;
                  _this.recordDetails(
                    paths,
                    exportType,
                    getExportRecords,
                    _this.getNowExportNum,
                    callback
                  );
                  return;
                }
                if (exportFileData.hasTopographyOriginalImage) {
                  if (topographyOriginal.eyeType === "OS") {
                    topographyOriginalObj.pupilOSImg = topographyOriginal.pupilImg;
                    topographyOriginalObj.corneaOSImg = topographyOriginal.obj.largeImgUrl;
                  }
                  if (topographyOriginal.eyeType === "OD") {
                    topographyOriginalObj.pupilODImg = topographyOriginal.pupilImg;
                    topographyOriginalObj.corneaODImg = topographyOriginal.obj.largeImgUrl;
                  }
                }
                // if (exportFileData.hasTopographyReport) {
                // 判断导出角膜瞳孔报告
                if (topographyOriginal.obj !== undefined) {
                  // 判断导出角膜瞳孔报告 在报告的vue 里面
                  _this.topographyMapValues = topographyOriginal.obj.mapValues;
                  // 判断存储角膜表格数据
                  if (exportFileData.hasTopographyOriginaTable) {
                    exportFileData.saveTopographyTableData(
                      topographyOriginal.obj.mapValues,
                      data.record,
                      _this.currentPatient,
                      topographyOriginal,
                      _this.dataShowSettings
                    );
                  }
                  if (exportFileData.hasTopographyEye) {
                    if (!exportEye) {
                      exportEye = new ExportEyeJson();
                    }
                    exportEye.addCTRecord(
                      _this.currentPatient,
                      data.record,
                      topographyOriginal.obj.casePath,
                      topographyOriginal.eyeType
                    );
                  }
                  if (exportFileData.hasTopographyMwf) {
                    if (!exportMwf) {
                      exportMwf = new ExportMwfXml();
                    }
                    exportMwf.addCTRecord(
                      _this.currentPatient,
                      data.record,
                      topographyOriginal.obj.casePath,
                      topographyOriginal.eyeType
                    );
                  }
                }
                // }
                // -----------------------------------------------------------------------------
                // _this.recordAll 改成 detailsMyselfArr
                const detailsMyselfArr = [];
                detailsMyselfArr.push(detailsMyself);
                _this.exportFun(
                  paths,
                  detailsMyselfArr,
                  arr,
                  {},
                  exportType,
                  _this.recordAllDetails,
                  getExportRecords,
                  topographyOriginalObj,
                  callback
                ); // topographyOriginalImage
              }
            );
          }
        });
      } else {
        callback(_this.recordAllDetails);
      }
    },
    // 封装导出报告功能
    exportFun(
      paths,
      recordAll,
      arr,
      records,
      exportType,
      recordAllDetails,
      getExportRecords,
      topographyOriginalObj,
      callback
    ) {
      let _this = this;
      exportFileData.exportPath(
        paths,
        recordAll,
        arr,
        records,
        exportType,
        recordAllDetails,
        topographyOriginalObj,
        function (exportPathData) {
          if (exportPathData.type === 0) {
            _this.getNowExportNum++;
            _this.recordDetails(
              paths,
              exportType,
              getExportRecords,
              _this.getNowExportNum,
              callback
            );
            return;
          }
          exportFileData.rootPath = exportPathData.obj.rootPath;
          // 存储干眼和角膜导出报告路径
          _this.exportFilesPath = exportPathData.obj.callbackPath;
          // 获取角膜地形图四象图文件夹名称
          _this.topographyFourPath = exportPathData.obj.callbackTopographyImagePath;
          _this.recordPrintList(_this.recordAllDetails[0], function (data) {
            if (data) {
              if (data.checkType === "dryeye" && data.checkType) {
                // 这里是干眼导出报告传值的地方 (选了就导出，不选就不导出)
                if (exportFileData.hasDryeyeReport) {
                  if (
                    data.dataOD.diagnosed &&
                    data.dataOS.diagnosed &&
                    data.dataOS &&
                    data.dataOD
                  ) {
                    _this.recordTwoInfo = data.dataOS;
                    _this.recordOneInfo = data.dataOD;
                  } else if (data.dataOS.diagnosed && !data.dataOD && data.dataOS) {
                    _this.recordOneInfo = data.dataOS;
                    _this.recordTwoInfo = "";
                  } else if (data.dataOD.diagnosed && !data.dataOS && data.dataOD) {
                    _this.recordOneInfo = data.dataOD;
                    _this.recordTwoInfo = "";
                  } else {
                    _this.recordTwoInfo = "";
                    _this.recordOneInfo = "";
                  }
                  // 拼接时间戳方便每次传值不一样，报告可以渲染
                  _this.startShowReport2 = Math.round(new Date());
                } else {
                  _this.getNowExportNum++;
                  _this.recordDetails(
                    paths,
                    exportType,
                    getExportRecords,
                    _this.getNowExportNum,
                    callback
                  );
                }
              } else if (data.checkType === "topography" && data.checkType) {
                // 未选角膜就是下一个

                if (exportFileData.hasTopograPhy) {
                  //  这里是角膜导出报告传值的地方
                  if (
                    data.dataOD.diagnosed &&
                    data.dataOS.diagnosed &&
                    data.dataOS &&
                    data.dataOD
                  ) {
                    if (_this.hasTopographyReportEyeType) {
                      _this.topographyFilesPath = _this.exportFilesPath.odPath;
                    } else {
                      _this.topographyFilesPath = _this.exportFilesPath.osPath;
                    }
                  } else if (data.dataOS.diagnosed && !data.dataOD && data.dataOS) {
                    _this.topographyFilesPath = _this.exportFilesPath.osPath;
                  } else if (data.dataOD.diagnosed && !data.dataOS && data.dataOD) {
                    _this.topographyFilesPath = _this.exportFilesPath.odPath;
                  }
                  // 拼接时间戳方便每次传值不一样，报告可以渲染
                  _this.startShowReport = Math.round(new Date());
                } else {
                  _this.getNowExportNum++;
                  _this.recordDetails(
                    paths,
                    exportType,
                    getExportRecords,
                    _this.getNowExportNum,
                    callback
                  );
                }
              } else {
                _this.getNowExportNum++;
                _this.recordDetails(
                  paths,
                  exportType,
                  getExportRecords,
                  _this.getNowExportNum,
                  callback
                );
              }
            }
          });
        }
      );
    },
    // 导出角膜 和 瞳孔图片 判断是否有左右眼和角膜瞳孔
    getTopographyImagePath(detailsMyself, eyeType, topographyOriginalObj, callback) {
      // console.log(exportFileData.hasTopograPhy)
      let _this = this;
      if (
        detailsMyself.checktype === "topography" &&
        eyeType !== undefined &&
        exportFileData.hasTopograPhy
      ) {
        let eyeSplit = eyeType.split(",");
        let eyeTypeIndexVal;
        // 取出角膜和瞳孔图片
        let pupilImg = "";
        let imageObj = {
          pupilImg: "",
          obj: "",
          eyeType: "",
          // 判断是否有瞳孔
          hasPupilImgType: false
        };
        // 根据左右眼取值 2次取不一样的值
        if (!_this.hasTopographyReportEyeType) {
          eyeTypeIndexVal = eyeSplit[0];
          if (eyeSplit.length > 1) {
            _this.hasTopographyReportEyeType = true;
          } else {
            _this.hasTopographyReportEyeType = false;
          }
        } else {
          eyeTypeIndexVal = eyeSplit[1];
          _this.hasTopographyReportEyeType = false;
        }
        imageObj.eyeType = eyeTypeIndexVal;
        let hasCasePathType = true;
        if (
          detailsMyself.content[`data${eyeTypeIndexVal}`] &&
          detailsMyself.content.hasOwnProperty(`data${eyeTypeIndexVal}`)
        ) {
          if (
            detailsMyself.content[`data${eyeTypeIndexVal}`].hasOwnProperty("pupilcorneadia") &&
            !detailsMyself.content[`data${eyeTypeIndexVal}`].hasOwnProperty("topography")
          ) {
            hasCasePathType = true;
            imageObj.hasPupilImgType = true;
          } else if (
            detailsMyself.content[`data${eyeTypeIndexVal}`].hasOwnProperty("topography") &&
            !detailsMyself.content[`data${eyeTypeIndexVal}`].hasOwnProperty("pupilcorneadia")
          ) {
            hasCasePathType = false;
            imageObj.hasPupilImgType = false;
          } else if (
            detailsMyself.content[`data${eyeTypeIndexVal}`].hasOwnProperty("topography") &&
            detailsMyself.content[`data${eyeTypeIndexVal}`].hasOwnProperty("pupilcorneadia")
          ) {
            hasCasePathType = false;
            imageObj.hasPupilImgType = true;
          }
        }
        exportFileData.getTopographyOriginImage(
          detailsMyself,
          eyeTypeIndexVal,
          _this.dataShowSettings,
          hasCasePathType,
          function (obj, error) {
            if (imageObj.hasPupilImgType) {
              pupilImg = exportFileData.getPupilOriginImage(
                detailsMyself.content[`data${eyeTypeIndexVal}`].pupilcorneadia.photos
              );
            }
            imageObj.pupilImg = pupilImg;
            imageObj.obj = obj;
            _this.casePath = obj.casePath;
            callback(imageObj, error);
          }
        );
      } else {
        callback(topographyOriginalObj);
      }
    },
    // 病例打印报告返回值
    recordPrintList(recordAllDetails, callback) {
      const details = recordAllDetails;
      let dataOS = "";
      let dataOD = "";
      let data = { checkType: false };
      if (details) {
        let checkType = details.checkType;
        if (details.hasOwnProperty("eyeType")) {
          if (details.eyeType.indexOf("OS") !== -1 && details.eyeType.indexOf("OD") === -1) {
            if (!details.dataOS.hasOwnProperty("topography")) {
              dataOS = details.dataOS;
            } else {
              dataOS = details.dataOS;
            }
          } else if (details.eyeType.indexOf("OD") !== -1 && details.eyeType.indexOf("OS") === -1) {
            if (!details.dataOS.hasOwnProperty("topography")) {
              dataOD = details.dataOD;
            } else {
              dataOD = details.dataOD;
            }
          } else if (details.eyeType.indexOf("OS") !== -1 && details.eyeType.indexOf("OD") !== -1) {
            if (!details.dataOS.hasOwnProperty("topography")) {
              dataOS = details.dataOS;
              dataOD = details.dataOD;
            } else {
              dataOS = details.dataOS;
              dataOD = details.dataOD;
            }
          }
        }
        data = {
          checkType: checkType,
          dataOS: dataOS,
          dataOD: dataOD
        };
      }
      callback(data);
    },
    // -------------病人-----------------------
    // 点击病人
    showRecordList(row) {
      this.currentPatients = row;
      this.recordsAll();
    },
    // 判断当前病人是否被选中
    currentPatientIsChecked(row) {
      let type = false;
      for (let i = 0; i < this.pCheckCurrentArr.length; i++) {
        if (this.pCheckCurrentArr[i]._id === row._id) {
          type = true;
          return type;
        }
      }
      return type;
    },
    // 判断当前病人病例是否被选中
    currentRecordIsChecked(row) {
      let type = false;
      for (let i = 0; i < this.recordCheckCurrentArr.length; i++) {
        if (this.recordCheckCurrentArr[i]._id === row._id) {
          type = true;
          return type;
        }
      }
      return type;
    },
    // 全局触发全选
    checkedInputAllFun() {
      this.checkedAll = !this.checkedAll;
      this.pNoCheckAllArr = [];
      this.reNoCheckAllArr = [];
      this.checkedAllFun();
      this.recordSelectedAllFun(this.checkedAll);
    },
    // 病人列表全选操作
    patientsSelection(val) {
      this.pCheckCurrentArr = [];
      this.patientCheckNum = 0;
      this.patientCheckNum = val.length + this.patientCheckNum;
      if (this.patientCheckNum === this.patientsData.length) {
        // 全选病人全选
        this.pCheckCurrentArr.push.apply(this.pCheckCurrentArr, this.patientsData);
        //  触发病例全选
        this.recordSelectedAllFun(true);
        for (let i = 0; i < this.patientsData.length; i++) {
          this.getNoCheckArrFun(true, this.patientsData[i]);
        }
      } else {
        this.pCheckCurrentArr = val;
      }
      // 反选
      setTimeout(() => {
        if (this.patientCheckNum === 0) {
          this.reNoCheckAllArr = [];
          if (this.checkedAll) {
            for (let i = 0; i < this.patientsData.length; i++) {
              this.getNoCheckArrFun(false, this.patientsData[i]);
            }
          }
          this.recordSelectedAllFun(false);
        }
      }, 0);
    },
    // 单选获取未选值
    onTableSelect(rows, row) {
      this.recordNum = 0;
      // 已选中值
      this.pCheckCurrentArr = rows;

      const type = this.currentPatientIsChecked(row);

      // 未选中值
      this.getNoCheckArrFun(type, row);
      if (row._id === this.currentPatients._id) {
        this.recordSelectedAllFun(type);
      }
    },

    // 判断全选选中所有
    checkedAllFun() {
      if (this.checkedAll) {
        setTimeout(() => {
          // 这是显示病人列表勾选样式
          for (let i = 0; i < this.patientsData.length; i++) {
            this.$refs.patientsTable.toggleRowSelection(this.patientsData[i], true);
            if (this.pNoCheckAllArr.length > 0) {
              for (let j = 0; j < this.pNoCheckAllArr.length; j++) {
                if (this.patientsData[i]._id === this.pNoCheckAllArr[j]._id) {
                  this.$refs.patientsTable.toggleRowSelection(this.patientsData[i], false);
                }
              }
            }
          }
        }, 0);
      } else {
        this.$refs.patientsTable.clearSelection();
      }
    },
    // 点击分页事件
    currentChange(e) {
      this.patientsPage = e;
      this.patientCheckNum = 0;
      this.patientsAll();
    },
    // 点击导出按钮操作
    exportFile() {
      this.dialogVisible = true;
    },
    // 导出方法
    processExport(exportType, exportTypeLength, dst) {
      if (dst === "toudisk") {
        const { status, location } = fileSys.isUDiskExits();
        if (!status) {
          this.message(this.$t("langcfg.txtDiskIsMountedFailed"), "error", 10000);
        } else {
          if (!fileSys.mkdirSync(this.exportRootPath)) {
            this.message(this.$t("langcfg.txtSharedFolderMountFailed"), "error");
            return;
          }
          this.exportStart(exportType, exportTypeLength);
        }
      } else {
        const { ip, folder, username, password, folderInLinux } = window.settings.sharedFolder;

        fileSys.mountSharedFS([`${ip}/${folder}`, `${username}`, `${password}`], (error) => {
          if (error) {
            this.message(this.$t("langcfg.txtSharedFolderMountFailed"), "error", 2000);
          } else {
            this.exportStart(exportType, exportTypeLength, folderInLinux);
          }
        });
      }
    },
    exportStart(exportType, exportTypeLength, exportPath) {
      let _this = this;
      _this.WaitExport = false;
      if (exportTypeLength <= 0) {
        _this.notify("error", _this.$t("langcfg.txtCheckFiles"));
        return;
      } else {
        _this.dialogVisible = false;
      }
      if (_this.progressButton) {
        _this.notify("error", _this.$t("langcfg.txtExportProgressNotify"));
        return;
      }
      exportFileData.hasReportTableFun(exportType);
      _this.showReport = true;
      exportFileData.getPathFun();
      let expPath = exportPath
        ? fileSys.combinePath(exportPath, "MwData_" + getSystemTime("", "_", ""))
        : _this.exportRootPath;
      if (!fileSys.mkdirSync(expPath)) {
        this.message(this.$t("langcfg.txtSharedFolderMountFailed"), "error");
        return;
      }
      _this.exportRecordAllData(expPath, exportType, exportPath);
    },
    backHomeClose() {
      this.dialogVisibleHome = false;
    },
    backHome() {
      this.stopExportType = true;
      this.$emit("hideExport");
    },
    cancel() {
      if (this.progressButton) {
        this.dialogVisibleHome = true;
      } else {
        this.backHome();
      }
      exportFileData.clearFile(this.exportRootPath, function (type) {
        if (type) {
        }
      });
    },
    handleClose(done) {
      done();
    },
    progressInput() {
      this.progressButton = false;
      this.progressShow = true;
    },
    fileExportClose() {
      this.dialogVisibleFile = false;
    },
    //  拷贝错误重新拷贝
    fileExport() {
      //  将本地拷贝至优盘
      let _this = this;
      exportFileData.copyToUdisk(
        _this.exportRootPath,
        _this.exportRootFile,
        this.compressFileStatus.fileName,
        function (type) {
          if (type) {
            _this.notify("success", _this.$t("langcfg.txtExportSuccess"));
            // 清空文件
            exportFileData.clearFile(_this.exportRootPath, function (type) {
              if (type) {
              }
            });
            setTimeout(function () {
              _this.progressShow = false;
              _this.WaitExport = false;
            }, 500);
          } else {
            _this.progressShow = false;
            _this.dialogVisibleFile = true;
          }
        }
      );
    },
    //  提示
    notify(type, text) {
      this.$notify({
        title: this.$t("langcfg.txtPrompt"),
        message: text,
        showClose: true,
        type: type,
        duration: 2500
      });
    },
    // 干眼导出后调取方法
    exportFinished(type) {
      // 隐藏 report
      this.showReport = false;
      let _this = this;
      if (type) {
        _this.getNowExportNum++;
        setTimeout(() => {
          this.showReport = true;
          _this.recordDetails(
            _this.getNowExportPaths,
            _this.getNowExportExportType,
            _this.getNowExportRecords,
            _this.getNowExportNum,
            _this.getNowExportCallback
          );
        }, 100);
      }
    },
    // 角膜导出后调取方法
    exportTopographyFinished(fourMap) {
      let _this = this;
      if (fourMap.type) {
        // 这是导出角膜地形图 ,有左右眼和有角膜和瞳孔图，os od 必须分开上传
        // 两个左右眼同时有的情况下，不加1
        if (!_this.hasTopographyReportEyeType) {
          _this.getNowExportNum++;
        }
        const fourPath = exportFileData.getNowPath(
          _this.topographyFilesPath,
          _this.topographyFourPath
        );
        // 如果选了角膜图则生成图片
        if (fourPath) {
          exportFileData.copyCorneaImage(fourMap, fourPath, function (type) {
            if (type) {
              _this.recordDetails(
                _this.getNowExportPaths,
                _this.getNowExportExportType,
                _this.getNowExportRecords,
                _this.getNowExportNum,
                _this.getNowExportCallback
              );
            }
          });
        } else {
          _this.recordDetails(
            _this.getNowExportPaths,
            _this.getNowExportExportType,
            _this.getNowExportRecords,
            _this.getNowExportNum,
            _this.getNowExportCallback
          );
        }
      }
    },
    //  -----弹窗--------
    progressClose() {
      this.progressButton = true;
      this.progressShow = false;
    },
    //  导出进度计算
    progressSum(num, sum) {
      this.percentage = Math.ceil((num / sum) * 100);
    }
  },
  mounted() {
    this.stopExportType = false;
    this.patientsAll();
    exportFileData.clearFile(this.exportRootPath, function (type) {
      if (type) {
      }
    });
  },
  beforeDestroy() {
    this.checkedAll = false;
  },
  watch: {
    dialogVisible(newVal) {
      this.hideOption = !newVal;
    }
  }
};
</script>
<style lang="less">
// 修改时间框
.el-picker-panel__footer {
  background: none;
}

.el-picker-panel__sidebar {
  background: none;
}
</style>
<style scoped lang="less">
.export-body {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 24px;
  line-height: 60px;

  .export-center {
    width: 10px;
  }

  .export-left {
    //border: 1px solid #00ff00;
    //flex: 1.2;
    width: 55%;
  }

  .export-right {
    //border: 1px solid #5a208d;
    //flex: 0.8;
    width: 45%;
  }

  .export-title {
    text-align: center;
    color: white;
    font-weight: bold;
    position: fixed;
    height: 80px;
    text-align: center;
    background: #2d3039;
    width: 34%;
    line-height: 80px;
    z-index: 10;
    font-size: 28px;
  }

  .export-check {
    text-align: center;
  }

  .export-list {
    font-size: 20px;
  }

  .export-bot {
    margin-top: 50px;
  }
}

/deep/ .el-checkbox__inner {
  width: 25px;
  height: 25px;
}

//把输入框变大
/deep/ .el-checkbox__inner::after {
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;
  left: 10px;
  top: 6px;
}

//把边框尺寸变大
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner::after {
  transform: rotate(45deg) scaleY(1.6);
}

/deep/ .el-table th > .cell {
  font-size: 25px;
}

/deep/ .is-center .cell {
  font-size: 24px;
}

/deep/ .el-pager li {
  height: 50px;
  padding: 12px 22px;
  font-size: 26px;
  line-height: 30px;
}

/deep/ .el-pagination.is-background .btn-prev {
  height: 50px;
  padding: 12px 22px;
}

/deep/ .el-pagination.is-background .btn-next {
  height: 50px;
  padding: 12px 22px;
}

/deep/ .el-pagination .btn-next .el-icon {
  font-size: 24px;
  line-height: 15px;
}

/deep/ .el-pagination .btn-prev .el-icon {
  font-size: 24px;
  line-height: 15px;
}

/deep/ .el-icon-circle-close:before {
  color: #737373;
}

// /deep/ .el-icon-success:before {
//   color: #409EFF;
// }

.success {
  color: @blue-selected-color;
}

#xu {
  /deep/ .el-input__inner {
    font-size: 24px;
    height: 45px;
    margin-left: 15px;
    float: left;
  }
}

/deep/ .el-date-table th {
  font-size: 20px;
}

/deep/ .el-date-table td div span {
  font-size: 18px;
}

/deep/ .el-picker-panel__sidebar {
  background: none;
}

/deep/ .el-picker-panel__footer {
  background: none;
}

/deep/ .el-picker-panel__icon-btn {
  font-size: 30px;
}

/deep/ .el-icon-arrow-right:before {
  color: white;
}

/deep/ .el-date-range-picker__header div {
  color: #ffffff;
}

/deep/ .el-picker-panel__shortcut {
  color: #ffffff;
}

/deep/ .el-icon-arrow-right {
  color: #606266;
}

/deep/ .el-icon-arrow-right:before {
  color: #606266;
}

/deep/ .el-input__inner .el-input__icon {
  font-size: 26px;
}

// ---
.setButton {
  float: right;
  margin-top: 10px;
  margin-right: 20px;

  button {
    border-right: 4px;
    resize: none;
    outline: none;
    font-size: 24px;
    color: #ffffff;
    width: auto;
    height: 55px;
    padding: 0 15px;
    cursor: pointer;
  }

  .cancel {
    background: #747473;
  }

  .export {
    background: #3f6ee8;
  }

  .progressButton {
    background: #3d3c4e;
  }
}

.CE .button:hover {
  opacity: 0.8;
}

.export-table {
  height: 850px;
  overflow: auto;

  .export-checkAll {
    margin-left: 30px;
    float: left;

    span {
      font-size: 22px;
    }

    cursor: pointer;
  }
}

#select {
  position: absolute;
}

.txtSelectType {
  font-size: 28px;
}

.progress {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.7);

  .progress-close {
    float: right;
    margin-right: 40px;
    margin-top: 30px;
  }

  .progressText {
    text-align: center;
    padding-bottom: 30px;
    font-weight: bold;
    font-size: 30px;
    color: #328ae5;
  }
}

.dialogHome-content {
  text-align: center;
  color: #ffffff;
  font-size: 26px;
  line-height: 100px;
  margin-bottom: 40px;
}

.el-icon-circle-close:before {
  color: #fff;
  cursor: pointer;
}
</style>
<style lang="less">
.el-date-range-picker__editor .el-input__inner {
  font-size: 22px;
}

.el-picker-panel__shortcut {
  color: #fff;
}

.el-date-range-picker__header div {
  font-size: 24px;
  color: #fff;
}

.el-date-picker__header-label,
.el-date-table th {
  font-size: 22px;
}

.el-date-editor .el-range-input {
  font-size: 22px;
}

.el-date-table td.in-range div {
  background-color: #7095cc;
}

.el-button.is-plain:hover,
.el-date-table td.in-range div,
.el-date-table td.in-range div:hover {
  background: #418ad4;
}

#export {
  .el-input.el-input--suffix {
    height: 48px;
  }

  .el-input__suffix {
    right: 1px;
    top: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/exportUserList/index.vue